import { render } from "./inputValidateText.vue?vue&type=template&id=60e81924&scoped=true&lang=pug"
import script from "./inputValidateText.vue?vue&type=script&lang=js"
export * from "./inputValidateText.vue?vue&type=script&lang=js"

import "./inputValidateText.vue?vue&type=style&index=0&id=60e81924&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e81924"]])

export default __exports__